$(document).ready(function() {
    $('.custom_bundle_wrap--main .prod_placeholder').on('click', function(){
      
        $('.main_products_patch_outer').slideDown(500);
        // $('.bundle_collection_wrap').slideDown(500);
        $('.custom_bundle_wrap--main .dropdown_title').addClass('bundle_active');
    });
        $('.custom_bundle_wrap--main .dropdown_title').on('click', function(){
         $('.main_products_patch_outer').slideToggle(500); 
         // $('.bundle_collection_wrap').slideToggle(500); 
        $(this).toggleClass('bundle_active');
    });
  // bundle select js start

  
//=== utk select code ==//
// Event listener for custom select buttons (both main list and quick view)
$(".cstm_select_button").on("click", function() {
    //$(".bundle_add_products").show();
    //$(".quantity-submit-row__submit").hide();
    // $(".Add_item_button.prod_placeholder").hide();
    var productItem = $(this).closest('.product_item_ud');
    var itemID = productItem.attr('data-pro-id');
    var mainId = productItem.attr('data-mainid');
    var itemprice = productItem.attr('select-price');
    var imageUrl = productItem.attr('data-pro-img');
    var itemhandle = productItem.attr('data-handle');
    var qtyToAdd = 1;

    // Check if quantity is specified in quick view popup
   var qtyFromPopup = parseInt(productItem.find("#quantity").val(), 10);
    // var qtyFromPopup = parseInt(productItem.find("#custom_quantityquickview").val(), 10);
    if (!isNaN(qtyFromPopup) && qtyFromPopup > 0) {
        qtyToAdd = qtyFromPopup;
    }
    
    var existingItem = $(".appended_items_main").find(`.appended_item[data-pro-id='${itemID}']`);
     
    if (existingItem.length) {
        var currentQty = existingItem.data('qty') || 0;
        var newQty = currentQty + qtyToAdd;
        existingItem.data('qty', newQty);
        existingItem.find('.item_qty').text(newQty);
    } else {
        var newDiv = `
            <div class="appended_item" data-pro-id="${itemID}" data-qty="${qtyToAdd}" data-price="${itemprice}" data-mainid="${mainId}" data-handle="${itemhandle}">
                <img class="prod_patchimg" src="${imageUrl}" alt="Product Image">
                <div class="quantity_edit_area">
                <span class="remove_item_button" data-price="${itemprice}"><img src='https://cdn.shopify.com/s/files/1/0723/3175/5797/files/Vector_4.svg'></span>
                <span class="item_qty">${qtyToAdd}</span>
                <span class="add_item_button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M7.9873 1V14.995M0.990234 7.99707H14.9853" stroke="black" stroke-width="0.999646" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>
                </div>
            </div>
        `;
        $(".appended_items_main").prepend(newDiv);

      
    }
  updateRemoveButtonImages();
  Apppendfunctionclick();
  
}); 
// get lenth
   function checkAndToggleButton() {
     
        if ($('.appended_items_main.appended_block_product .appended_item').length === 0) {
            $('.Add_item_button.prod_placeholder').show();
            //$('.quantity-submit-row__submit').show();
            //$('.bundle_add_products').hide();
            
        } else {
            $('.Add_item_button.prod_placeholder').hide();
            //$('.quantity-submit-row__submit').hide();
            //$('.bundle_add_products').show();
        }
    }
    $('body').on('click', function() {
        checkAndToggleButton();
    });
    // Initially call the function to set the correct state
    checkAndToggleButton();
// end 
// Event delegation for remove item button
$(".appended_items_main").on("click", ".remove_item_button", function() {
    var parentItem = $(this).closest(".appended_item");
    var qty = parentItem.data('qty') || 1;
    var mainID = parentItem.data('pro-id');
    qty--;
    if (qty <= 0) {
        parentItem.remove();
    } else {
        parentItem.data('qty', qty);
        parentItem.find('.item_qty').text(qty);
    }
    $('.selectpatch_pop_img').each(function(){
      var popimgid = $(this).attr('data-pro-id');
      if (qty <= 0) {
        if(popimgid == mainID ){
           $(this).remove();
        }
      }
    });
    updateRemoveButtonImages();
});
//if quantity txt is equal to 1 function start  
function updateRemoveButtonImages() {
    var dustdinsrc = 'https://cdn.shopify.com/s/files/1/0723/3175/5797/files/Vector_4.svg';
    var minussrc = 'https://cdn.shopify.com/s/files/1/0723/3175/5797/files/Vector_3.svg';

    $(".quantity_edit_area").each(function() {
        var quantity = parseInt($(this).find('.item_qty').text());
        if (quantity === 1) {
            $(this).find('.remove_item_button img').attr('src', dustdinsrc);
        } else {
            $(this).find('.remove_item_button img').attr('src', minussrc);
        }
    });
}
//if quantity txt is equal to 1 function end 
// plus icon function start
  $(".appended_items_main").on("click", ".add_item_button", function() {
    var parentItem1 = $(this).closest(".appended_item");
    var qty1 = parentItem1.data('qty') || 1;
    qty1++;
    parentItem1.data('qty', qty1);
    parentItem1.find('.item_qty').text(qty1);
    updateRemoveButtonImages();
});
// plus icon function end
// Selected add to cart ajax function
$(".bundle_add_products").on('click', function() {
  $(".bundle_add_products .text_btn").hide();
  $(".bundle_add_products .loader_main_up").show();

 var productsToAdd = []; 

    var buttonDataId = $(this).attr("data-id");
    var currentUrl = window.location.href;

    // Parse the current URL to check for `?variant=`
    var urlParams = new URLSearchParams(currentUrl.split("?")[1]); // Get query parameters
    var variantId = urlParams.get("variant"); // Extract `variant` value if present

    // Determine the ID to use (either variant ID from URL or default button data-id)
    var idToUse = variantId ? variantId : buttonDataId;
    var mainqty = $('#quantity').val();
    // Add the button's data-id (or variant ID) to the array with a default quantity of 1
    productsToAdd.push({
        id: idToUse,
        quantity: mainqty, // Default quantity for the button's product
    });

    // Collect product IDs and quantities from appended items
    $(".appended_item").each(function () {
        var defaultId = $(this).attr("data-pro-id"); // Default data-id from the element
        var qty = parseInt($(this).find(".item_qty").text(), 10); // Get quantity
        productsToAdd.push({
            id: defaultId,
            quantity: qty,
        });
    });

    console.log("Products to add:", productsToAdd); // Debugging log for verification


  // Function to add all products at once
    function addAllProductsToCart(products, callback) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js", // Shopify endpoint for adding products
            data: JSON.stringify({ items: products }), // Send all products in one request
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
                console.log("All products added to cart:", data);
                if (callback) callback();
                $(".bundle_add_products .text_btn").show();
                $(".bundle_add_products .loader_main_up").hide();
            },
            error: function (xhr, status, error) {
                console.error("Error adding products to cart:", xhr.responseText);
                if (callback) callback();
            },
        });
    }
  
   function checkleterpatchitem() {
        $('.product-letter-input').each(function() {
            // var preview = $(this).closest('.letter_picker_withatc').find('.letter-picker-preview');
          var letterpatchbtn = $('.letter_picker_withatc button.button-large.button.add-letters-to-cart');
            if ($(this).val().trim() === '') {
                letterpatchbtn.prop('disabled', true); // Disabling the button
                //alert('No letters to add to the cart'); // Displaying an alert
            } else {
              // setTimeout(function(){
              //   //letterpatchbtn.trigger('click');
              // }, 1000);
            }
        });
    }

      // Add all products and handle post-addition actions
    addAllProductsToCart(productsToAdd, function () {
        console.log("Products successfully added!");
        // Trigger letter patch button if applicable
        if ($(".letter-picker-preview img.letter-preview-img").length > 0) {
            $(".letter_picker_withatc .add-letters-to-cart").trigger("click");
        }
        // Trigger final checkout button
       // $(".quantity-submit-row__submit.input-row button.button.button--large").trigger("click");
       if ($('body').hasClass('redirect-checkout')) {
        window.location.href = "/checkout";
    } else {
        console.log("Body does not have the class 'template-suffix-redirect-checkout'.");
          document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
    }
            
    });
});
// === UTK end === //
  // bundle select js end
  //show quick view start
$('.bundle_prod_cont_wrap span.button_quick_view, .budle_prod_img').on('click', function(){
  // Hide all other quick view sections
  $('.custm_bundle_quickview_wrap').hide();
  // Show the quick view section of the clicked item's parent
  $(this).closest('.colletion_item').find('.custm_bundle_quickview_wrap').show();
  $('body').addClass('cust_quick_view_open overflow-hidden');
  $(this).closest('.colletion_item').find('.custm_bundle_quickview_wrap').addClass('open_current_view');

    // $(".quickview_imgslide .button-prev").trigger('click');
    $('.quickview_imgslide').slick('setPosition');
    //console.log(123456);

});
$('.popupselectbtn .cstm_select_button').on('click', function(){ 
  $('.custm_bundle_quickview_wrap .icon_close').trigger('click');
});
$('.custm_bundle_quickview_wrap .icon_close').on('click', function(){ 
  $('.custm_bundle_quickview_wrap').hide();
  $('body').removeClass('cust_quick_view_open overflow-hidden');
   $('.custm_bundle_quickview_wrap').removeClass('open_current_view');
});
$('.button_selectbtn.cstm_select_button').on('click', function(){
    setTimeout (function(){
       $('.quick_view_quantity_select input').val(1);
    }, 1000);
});  
// show quick view end
$('.Show_price-descriptors').on('click', function(){
    $('.price-descriptors').slideToggle('500');
    $(this).toggleClass('active');
});
  // check letter pack toogle and length start
 function checkInputAndToggleVisibility() {
        $('.product-letter-input').each(function() {
            var preview = $(this).closest('.letter_picker_withatc').find('.letter-picker-preview');
            if ($(this).val().trim() === '') {
                preview.hide();
            } else {
                preview.show();
            }
        });
    }
    checkInputAndToggleVisibility();
    $('.letter_picker_withatc .letterpicatc_accod_title').on('click', function() {
      $(this).toggleClass('bundle_active');
        $(this).siblings('.letterpickatc_inner').slideToggle(500, function() {
            checkInputAndToggleVisibility();
        });
    });
    $('.product-letter-input').on('input', function() {
        checkInputAndToggleVisibility();
    });
  // check letter pack length end
  // custom scroll event start
  var lastScrollTop = 0;
        var $scrollElement = $('.main_products_grid_cstm.bundle_collection_wrap');
        $scrollElement.on('scroll', function() {
            var addon = $('.main_products_patch_outer');
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(this)[0].scrollHeight;
            var elementHeight = $(this).innerHeight();
            if (scrollTop === 0) {
                $(addon).removeClass('scrolltop scrolldown');
            }
            else if (scrollTop + elementHeight >= scrollHeight) {
                $(addon).removeClass('scrolltop scrolldown');
            }
            else {
                if (scrollTop > lastScrollTop) {
                    $(addon).removeClass('scrolltop').addClass('scrolldown');
                } else {
                    $(addon).removeClass('scrolldown').addClass('scrolltop');
                }
            }

            lastScrollTop = scrollTop;
        });
  // custom scroll event end
  // selectedpatch popupstart
  
function Apppendfunctionclick () {

$('.appended_items_main .appended_item .prod_patchimg').on('click', function(){
    var varID = $(this).closest('.appended_item').attr('data-pro-id');
    var varprodhandle = $(this).closest('.appended_item').attr('data-handle');
    var custURl = 'https://rabbleclothing.com/products/' + varprodhandle + '?variant=' + varID;
    var selectedPOPitem = '';
    //console.log('custURl=> ', custURl); 
    $.ajax({
          url: custURl,
          type: 'GET',
          dataType: 'json',
          success: function(data) {
          var allImages = data.product.images;
            // Clear existing content before appending new images
            //$(".apped_selected_item_pop .popselected_item").html('');
          
            allImages.forEach(function(image, index) {
              selectedPOPitem = `<div class="selectpatch_pop_img selected_imgpatch">
              <div class="selct_imgwrap">
              <img src="${image.src}" alt="Product Image">
              </div>
              </div>`;
              
              //console.log($('.selectpatch_pop_img').length);
              //console.log('Append item ' + selectedPOPitem);
               $(".apped_selected_item_pop .popselected_item").append(selectedPOPitem);
              $(".apped_selected_item_pop .popselected_item").addClass('selpatchimg_slide');
            });
          },
            error: function(jqXHR, textStatus, errorThrown) {
              console.error("Error fetching images:", errorThrown);
            }
    });
  //$(".apped_selected_item_pop .popselected_item").append(selectedPOPitem);
    setTimeout(function(){
      $('.apped_selected_item_pop.cust_popseletd').show();
      $('body').addClass('select_patchpop_open');
      //$('.selpatchimg_slide').slick('refresh');
    },950);
    setTimeout(function(){
      $('.selpatchimg_slide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow:`<div class="button-prev slick-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></div>`,
        nextArrow:`<div class="button-next slick-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></div>`,
        speed: 500
        // fade: true,
        // cssEase: 'linear'
      });  
    },1000);    
    // setTimeout(function(){
    // $('.apped_selected_item_pop.cust_popseletd').show();
    // $('body').addClass('select_patchpop_open');
    // $('.selpatchimg_slide').slick('refresh');
    // },950);
});


$('.apped_selected_item_pop .icon_close').on('click', function(){
$('.apped_selected_item_pop.cust_popseletd').hide();
$('body').removeClass('select_patchpop_open');
$('.selpatchimg_slide').slick('unslick');
$(".apped_selected_item_pop .popselected_item").html('');
$(".apped_selected_item_pop .popselected_item").removeClass('selpatchimg_slide');
});

}    

var itemnoselector = $('.sticky_addtocart_wrap .itemselected_atc .text_pro_ccount');
var pricechangesel = $('.sticky_addtocart_wrap .price_with_btn .priceDefault');
var addonpriceselector = $('.sticky_addtocart_wrap .price_with_btn');
var btnitemselector = $('.bundle_add_products .itemselected_atc .text_pro_ccount');
var btnpriceselector = $('.bundle_add_products .price_with_btn .priceDefault');
var pricedefault = '';
var defaultqty = '';
//main quantity change start
$('.quantity-wrapper.main_qtyselect').on('click', '.plus, .minus', function() {
    var isPlus = $(this).hasClass('plus');
    var qtyChange = parseInt(itemnoselector.attr('value'), 10) * (isPlus ? 1 : -1);
    var currentQty = parseInt(itemnoselector.text(), 10);
    var newQty = currentQty + qtyChange;
    //console.log('Qty change=> ', qtyChange);
    //console.log('New qty=> ', newQty);
    btnitemselector.text(newQty);

    var priceChange = parseInt(addonpriceselector.attr('data-price'), 10) * (isPlus ? 1 : -1);
    var currentPrice = parseInt(pricechangesel.text(), 10);
    var newPrice = currentPrice + priceChange;
    //console.log('Price change=> ', priceChange);
    //console.log('New price=> ', newPrice);
    btnpriceselector.text(newPrice);
});
//main quantity change end
$('.product_item_ud .cstm_select_button').each(function(){
    $(this).on('click', function(){
      //var itemselt = $(this).closest('.product_item_ud');
      var itemprice = parseInt($(this).attr('select-price'), 10);
         pricedefault = parseInt(pricechangesel.text(), 10);
        //console.log('pricedefault => ', pricedefault );
         //console.log('itemprice => ', itemprice );
      var priceadd = pricedefault + itemprice;
      //console.log('itmtotaoll==> ', priceadd);
      btnpriceselector.text(priceadd);
     //itetext change
        defaultqty = parseInt(itemnoselector.attr('value'), 10);
        var plusitemwith =  parseInt(itemnoselector.text(), 10);
        var finaladd = plusitemwith + defaultqty;
        btnitemselector.text(finaladd);
        // console.log(priceadd);
        // console.log(finaladd);
    });
});
   $(document).on('click', '.appended_item .remove_item_button', function() {
    var itemremove = parseInt($(this).closest('.appended_item').data('price'), 10);
    var btntxtminus = parseInt(pricechangesel.text(), 10);
    var priceminus = btntxtminus - itemremove;
    //console.log(btntxtminus, 'minus', itemremove, 'equal to=>', priceminus);
    btnpriceselector.text(priceminus);

    var currentCount = parseInt(itemnoselector.text(), 10);
    btnitemselector.text(currentCount - 1);
    //console.log("Crnt Val==>>", currentCount - 1);
  });

  $(document).on('click', '.appended_item .add_item_button', function() {
    var itemaddprice = parseInt($(this).closest('.appended_item').data('price'), 10);
    var btntxtplus = parseInt(pricechangesel.text(), 10);
    var priceplus = btntxtplus + itemaddprice;
    //console.log(btntxtplus, 'plus', itemaddprice, 'equal to=>', priceplus);
    btnpriceselector.text(priceplus);

    var currentCount = parseInt(itemnoselector.text(), 10);
    btnitemselector.text(currentCount + 1);
    //console.log("Crnt Val==>>", currentCount + 1);
  });

// update price item with letter patch start
// var patchno = parseInt($('.sticky_addtocart_wrap .itemselected_atc .text_pro_ccount').text(), 10);
// var curentprice = parseInt($('.sticky_addtocart_wrap .price_with_btn .priceDefault').text(), 10);
// var patchno = parseInt(itemnoselector.text(), 10);
// var curentprice = parseInt(pricechangesel.text(), 10);

$('.product-letter-input').on('keyup change paste', function() {
var patchno = parseInt(itemnoselector.text(), 10);
var curentprice = parseInt(pricechangesel.text(), 10);
    var inputVal = $(this).val();
    var prevVal = $(this).data('prevVal') || "";
//console.log('prevVal=> ', prevVal);
    var letterpatchprice;
    
     // letterpatchprice = 3;
     letterpatchprice = parseInt($('.letter_picker_withatc .letterpic_dropdown_title').attr('letter-price'), 10);
      //console.log(letterpatchprice, 'settingPrice');
    // $('.letter-preview-img').each(function() {
    //     letterpatchprice = parseInt($(this).data('price'), 10);
    //   console.log(letterpatchprice, '');
    // });

    if (inputVal.length > prevVal.length) {
        // Letter has been typed
        patchno++;
        curentprice += letterpatchprice;

        $('.bundle_add_products .itemselected_atc .text_pro_ccount').text(patchno);
        $('.bundle_add_products .price_with_btn .priceDefault').text(curentprice);
    } else if (inputVal.length < prevVal.length) {
        // Letter has been removed
        patchno--;
        curentprice -= letterpatchprice;

        $('.bundle_add_products .itemselected_atc .text_pro_ccount').text(patchno);
        $('.bundle_add_products .price_with_btn .priceDefault').text(curentprice);
    }

    $(this).data('prevVal', inputVal);
});

// update price item with letter patch end


 
// getting item select value and price end
  
});